import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'nominas/fechas-devoluciones-empleados';

/**
 * GET Fechas Devoluciones Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getFechasDevoulucionesEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
